export const APPEARANCE_PREFERENCE_KEY = "signaltunerAppearancePreference";

export function getAppearancePreference() {
  return localStorage.getItem(APPEARANCE_PREFERENCE_KEY) === "light" ? "light" : "dark";
}

export function saveAppearancePreference(appearance) {
  if (appearance === "dark" || appearance === "light") {
    localStorage.setItem(APPEARANCE_PREFERENCE_KEY, appearance);
  }
}
